import type { SVGProps } from "react";
const SvgAward = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    fontSize="1rem"
    {...props}
  >
    <g clipPath="url(#award_svg__a)">
      <path
        fill="#FF073B"
        d="M11.999.2a7.8 7.8 0 0 1 4.647 14.063l1.146 8.632a.8.8 0 0 1-1.204.79l-4.589-2.753-4.589 2.754a.8.8 0 0 1-1.204-.791l1.146-8.631A7.8 7.8 0 0 1 11.999.2m3.15 14.935a7.8 7.8 0 0 1-3.15.665 7.8 7.8 0 0 1-3.15-.665l-.84 6.324 3.579-2.145.098-.05a.8.8 0 0 1 .724.05l3.577 2.146zM11.998 1.8a6.2 6.2 0 1 0 3.304 11.445 1 1 0 0 1 .111-.071A6.2 6.2 0 0 0 12 1.8"
      />
    </g>
    <defs>
      <clipPath id="award_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAward;
